// src/pages/MapView.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllGeoJSON } from "../slices/mapSlice";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "../design/MapView.css";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

export default function MapView() {
  const dispatch = useDispatch();
  const { features, status, error } = useSelector((state) => state.map);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAllGeoJSON());
    }
  }, [dispatch, status]);

  if (status === "loading") {
    return (
      <div className="k-map-root">
        <div className="k-map-card">
          <div className="k-map-header">
            <h2>Devices Map</h2>
            <span className="k-map-subtitle">Loading map…</span>
          </div>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="k-map-root">
        <div className="k-map-card">
          <div className="k-map-header">
            <h2>Devices Map</h2>
            <span className="k-map-subtitle error">
              Error loading map: {error}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="page-header">
        <div className="page-breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/home">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item><Link to="/kentyouhome">Kentyou Data Visualisations</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Map</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
    <div className="k-map-root">
      <div className="k-map-card">
        <div className="k-map-header">
          <div>
            <h2>Devices Map</h2>
            <span className="k-map-subtitle">
              Visualizing gateways, watches & NOAH devices
            </span>
          </div>
          {/* Optional small legend placeholder */}
          <div className="k-map-legend">
            <span className="k-map-dot gw" /> Gateway
            <span className="k-map-dot watch" /> Watch
            <span className="k-map-dot noah" /> NOAH
          </div>
        </div>

        <div className="k-map-container">
          <MapContainer
            center={[41.3872, 2.1117]}
            zoom={10}
            className="k-map-leaflet"
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="© OpenStreetMap contributors"
            />
            <GeoJSON data={{ type: "FeatureCollection", features }} />
          </MapContainer>
        </div>
      </div>
    </div></>
  );
}
